import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class IconBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iconbox : [
                {
                    id: 1,
                    icon: "./assets/icon/icon_Increased Productivity.svg",
                    title: "Increased Productivity",
                    text: "A dedicated workspace away from the distractions of your home can significantly boost your productivity."
                },
                {
                    id: 2,
                    icon: "./assets/icon/icon_Cost-Effective.svg",
                    title: "Cost-Effective",
                    text: "Building a garden office is a cost-effective alternative to home extensions or renting external office spaces."
                },
                {
                    id: 3,
                    icon: "./assets/icon/icon_Connection with Nature.svg",
                    title: "Connection with Nature",
                    text: "Enjoy the serenity of your garden while working, which can lead to reduced stress and enhanced creativity."
                },
                {
                    id: 4,
                    icon: "./assets/icon/icon_Fast Installation.svg",
                    title: "Fast Installation",
                    text: "Our efficient installation process means you can have your garden office up and running in no time."
                }
            ]
        }
    }
    
    render() {
        return (
            <div className="row">
                {
                    this.state.iconbox.map(data => (
                        <div className="col-md-3" key={data.id}>
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                            <div className="themesflat-content-box clearfix" data-margin="0 5px 0 5px" data-mobilemargin="0 0 0 0">
                                <div className="themesflat-icon-box icon-top align-center has-width w95 circle light-bg accent-color style-1 clearfix">
                                    <div className="icon-wrap">
                                        <img src={data.icon} />
                                    </div>
                                    <div className="text-wrap">
                                        <h5 className="heading"><Link to="#">{data.title}</Link></h5>
                                        <div className="sep clearfix" />
                                        <p className="sub-heading">{data.text}</p>
                                    </div>
                                </div>
                            </div>                                       
                        </div>  
                    ))
                }                    
            </div>
        );
    }
}

export default IconBox;